let lastSelectedVariantId = null;

$(document).ready(function () {

  function updatePriceState() {
    let $checked = $(".custom-varinat-input-name:checked");

    if ($checked.closest(".slideitem").hasClass("slide-item-sale")) {
      // $(".price.price--large").addClass("price--on-sale");
    } else {
      // $(".price.price--large").removeClass("price--on-sale");
    }
  }

  updatePriceState();

  $(document).on("change", ".custom-varinat-input-name", updatePriceState);

  $(document).on("change", ".custom-varinat-input-name", function () {
    window.__activeVariantInput = $(this);

    if (typeof window.updateRechargePrice === "function") {
      setTimeout(window.updateRechargePrice, 50);
    }
  });


  function checkRadioState() {

    if ($('.onetime-radio').hasClass('rc-radio--active')) {

      updatePriceState();

      $("body").removeClass('sub-active');
      $("body").addClass('one-time-active');

      $(".custom-save-price-one").removeClass('hidden');
      $(".custom-save-price-autoship").addClass('hidden');

      $(".count-result-onetime").removeClass('hidden');
      $(".count-result-autoship").addClass('hidden');

      $(".custom-main-product .price--sold-out .price__availability, .custom-main-product .price__regular")
        .css("display", "none");

      $(".custom-main-product .price__sale")
        .css("display", "block");
    }


    if ($('.subscription-radio').hasClass('rc-radio--active')) {

      updatePriceState();

      const variantCompare = $(".custom-varinat-input-name:checked").attr("data-compareprc");

      if (!variantCompare) {

      } else {
        $("body").removeClass("active-campare-price");
      }

      $(".custom-save-price-one").addClass('hidden');
      $(".custom-save-price-autoship").removeClass('hidden');

      $(".count-result-onetime").addClass('hidden');
      $(".count-result-autoship").removeClass('hidden');

      $(".discount20_price").removeClass('hidden');

      $("body").addClass('sub-active');
      $("body").removeClass('one-time-active');

      $(".regularsa-cut-price").removeClass('hidden');
      $(".bfcm-regular-price").addClass("hidden");

      $(".custom-variant-radios").addClass('active-autoship');

      $(".custom-main-product .price--sold-out .price__availability, .custom-main-product .price__regular")
        .css("display", "block");

      $(".custom-main-product .price__sale")
        .css("display", "none");
    }
  }

  checkRadioState();

  setInterval(checkRadioState, 500);


  setTimeout(function () {

    if ($('.rc-template__radio').length > 0) {

    } else {
      $(".count-result-autoship").addClass('hidden');
    }

    let dis5Price = $('.custom-varinat-input-name:checked').attr('variant_discount5_price');

    $("#discount-percentage-inner").text(dis5Price + ' (-5%)');


    const $label = $('label.onetime-radio');

    $label.each(function () {

      const $span = $(this).find('span.rc-radio__label');

      const fullText = $span.text().trim();

      const match = fullText.match(/^(.*?)(\$\d+(\.\d{2})?)$/);

      if (match) {

        const labelText = match[1].trim();
        const priceText = match[2];

        $('<p class="one-time-purchase-text"></p>')
          .text(labelText)
          .insertBefore($span);

        $span
          .text(priceText)
          .addClass('orignal-price-data');
      }
    });

  }, 500);


  setTimeout(function () {

    const onetimeRadio = document.querySelector('.onetime-radio');

    let productIdMatch = $(".custom-varinat-input-name").attr("data-product-id");

    if (onetimeRadio && !document.querySelector('.offer-one-sale-bfcm')) {

      const offerDiv = document.createElement('div');

      offerDiv.className = 'offer-one-sale-bfcm';

      offerDiv.innerHTML =
        `<span class="onetimelimited">37% LIMITED TIME DEAL</span>`;

      onetimeRadio.parentNode.insertBefore(offerDiv, onetimeRadio);
    }


    $(".count-result-onetime").removeClass('active-hidden');

    const SelectedVariantValue =
      $(".custom-varinat-input-name:checked").attr("data-value");

    if (SelectedVariantValue > 400) {

      if (productId === "15134852252019") {

        $(".rc-widget").show();

      } else {

        $(".rc-widget").hide();

        window.variantStrings.addToCart = "Add to Cart";

        const submitButton =
          document.querySelector(".custom-product-form__submit");

        const span = submitButton?.querySelector("span");

        if (span) {
          span.textContent = window.variantStrings.addToCart;
        }

        const oneTimeRadio =
          document.getElementById("rc-radio2");

        const hiddenOneTimeRadio =
          document.querySelector(
            ".rc-widget input.rc-radio__input.rc_widget__option__input--onetime"
          );

        if (oneTimeRadio) oneTimeRadio.click();

        if (hiddenOneTimeRadio) hiddenOneTimeRadio.click();
      }

    } else {

      $(".rc-widget").show();
    }


    const initialPricing = getSelectedVariantPricing();

    if (initialPricing && initialPricing.oneTimeSavings > 0) {
      $(".onetimelimited")
        .text(formatBadgePercent(initialPricing.oneTimePercent) + '% LIMITED TIME DEAL')
        .show();
    } else {
      $(".onetimelimited").hide();
    }

    if (initialPricing) {
      $(".save-perct").text(formatBadgePercent(initialPricing.autoshipPercent) + '%');
    }

  }, 1000);


  const setSliderWidth = () => {

    const win = $('.custom-variant-picker').width();

    const newWidth = win - 70;

    $('.variantslider').css('max-width', newWidth + 'px');
  };

  setSliderWidth();

  $(window).on('resize', setSliderWidth);


  $('.custom-variant-radios').each(function () {

    const self = $(this);

    const totalWidth = self.width() - 70;

    let itemWidth = 0;

    self.find('.slideitem').each(function () {
      itemWidth += $(this).outerWidth(true);
    });

    if (itemWidth > totalWidth) {
      self.find('.custom-slide-arrows').removeClass('hidden');
    }
  });


  $('span.customnext').click(function () {

    var toscroll =
      $(this)
        .parents('.customslide')
        .find('.slideitem.active')
        .next()
        .width();

    $(this)
      .parents('.customslide')
      .find('.variantslider')
      .animate({
        scrollLeft: "+=" + toscroll + "px"
      });
  });


  $('span.customprev').click(function () {

    var toscroll =
      $(this)
        .parents('.customslide')
        .find('.slideitem.active')
        .next()
        .width();

    $(this)
      .parents('.customslide')
      .find('.variantslider')
      .animate({
        scrollLeft: "-=" + toscroll + "px"
      });
  });


  const $checkedInput =
    $(".custom-varinat-input-name:checked");

  if ($checkedInput.length) {

    const $slideItem =
      $checkedInput.closest(".slideitem");

    const $variantSlider =
      $slideItem.closest(".variantslider");

    centerSlide($slideItem, $variantSlider);
  }


  $(".custom-varinat-input-name").click(function () {

    const $clickedInput = $(this);

    const clickedId = $clickedInput.attr("id");

    if (clickedId === lastSelectedVariantId) return;

    lastSelectedVariantId = clickedId;


    const $slideItem =
      $clickedInput.closest(".slideitem");

    const $customSlide =
      $clickedInput.parents(".customslide");

    const $variantSlider =
      $customSlide.find(".variantslider");


    $customSlide
      .find(".slideitem")
      .removeClass("current-slide");

    $slideItem.addClass("current-slide");


    centerSlide(
      $slideItem,
      $variantSlider
    );


    const qtyVal =
      $clickedInput.val();

    const qtySplitVal =
      qtyVal.split(" ");

    const priceVal =
      parseInt(qtySplitVal[0], 10);


    let productIdValue =
      $(".custom-varinat-input-name")
        .attr("data-product-id");


    if (priceVal > 400) {

      if (productIdValue === "15134852252019") {

        $(".rc-widget").show();

      } else {

        window.variantStrings.addToCart = "Add to Cart";

        const submitButton =
          document.querySelector(
            ".custom-product-form__submit"
          );

        const span =
          submitButton?.querySelector("span");

        if (span) {
          span.textContent =
            window.variantStrings.addToCart;
        }

        $(".rc-widget").hide();


        const oneTimeRadio =
          document.getElementById("rc-radio2");

        const hiddenOneTimeRadio =
          document.querySelector(
            ".rc-widget input.rc-radio__input.rc_widget__option__input--onetime"
          );


        if (oneTimeRadio) {
          oneTimeRadio.click();
        }

        if (hiddenOneTimeRadio) {
          hiddenOneTimeRadio.click();
        }
      }

    } else {

      $(".rc-widget").show();
    }


    if (typeof window.updateRechargePrice === "function") {

      setTimeout(() => {

        const subRadio =
          document.getElementById('rc-radio1');

        if (subRadio) {
          subRadio.removeAttribute('data-base-price');
        }

        const originalSubChecked =
          subRadio?.checked;

        if (subRadio) {
          subRadio.checked = true;
        }

        window.updateRechargePrice();

        if (subRadio) {
          subRadio.checked =
            originalSubChecked;
        }

        window.updateRechargePrice();

      }, 100);
    }

  });


  function centerSlide(
    $slideItem,
    $variantSlider
  ) {

    if (
      $slideItem.length &&
      $variantSlider.length
    ) {

      const slideLeft =
        $slideItem.position().left;

      const slideWidth =
        $slideItem.outerWidth(true);

      const containerWidth =
        $variantSlider.outerWidth();

      const containerScrollLeft =
        $variantSlider.scrollLeft();

      const scrollTo =
        containerScrollLeft +
        slideLeft -
        (containerWidth / 2) +
        (slideWidth / 2);


      $variantSlider.animate(
        {
          scrollLeft: scrollTo
        },
        {
          duration: 150,
          easing: "swing"
        }
      );
    }
  }


  lastSelectedVariantId =
    $(".custom-varinat-input-name:checked")
      .attr("id") || null;

});


function getSelectedVariant() {

  const wrapper =
    document.querySelector('variant-radios');

  if (!wrapper) return null;


  const script =
    wrapper.querySelector(
      'script[type="application/json"]'
    );

  if (!script) return null;


  const variants =
    JSON.parse(script.textContent);


  const selectedOptions = [];


  wrapper
    .querySelectorAll('.custom-variant-radios')
    .forEach(group => {

      const checked =
        group.querySelector(
          '.custom-varinat-input-name:checked'
        );

      if (checked) {
        selectedOptions.push(
          checked.value
        );
      }
    });


  if (!selectedOptions.length) {
    return null;
  }


  return variants.find(variant =>
    variant.options.every(
      (opt, index) =>
        opt === selectedOptions[index]
    )
  ) || null;
}


function formatBadgePercent(value) {
  return (Math.round(value * 10) / 10).toFixed(1).replace(/\.0$/, '');
}

function getSelectedVariantPricing() {
  const variant = getSelectedVariant();
  if (!variant) return null;

  const oneTimePrice = variant.price / 100;
  const compareAtPrice = variant.compare_at_price && variant.compare_at_price > 0
    ? variant.compare_at_price / 100
    : oneTimePrice;
  const customerTags = window.customerTags || '';
  const isSubscriber = customerTags.includes('Active Subscriber') || customerTags.includes('Inactive Subscriber');
  const autoshipPrice = oneTimePrice * (isSubscriber ? 0.95 : 0.8);
  const oneTimeSavings = Math.max(compareAtPrice - oneTimePrice, 0);
  const autoshipSavings = Math.max(compareAtPrice - autoshipPrice, 0);

  return {
    variant,
    oneTimeSavings,
    autoshipSavings,
    oneTimePercent: compareAtPrice > 0 ? (oneTimeSavings * 100) / compareAtPrice : 0,
    autoshipPercent: compareAtPrice > 0 ? (autoshipSavings * 100) / compareAtPrice : 0
  };
}



(function () {

  function updateRechargePrice() {

    const priceElement =
      document.querySelector(
        '.price-item--regularsa'
      );

    if (!priceElement) return;


    const isCustomerLoggedIn =
      window.customerLoggedIn === true;

    const customerTags =
      window.customerTags || "";


    const isSubscriber =
      customerTags.includes("Active Subscriber") ||
      customerTags.includes("Inactive Subscriber");


    const shouldApplyDiscount =
      !isCustomerLoggedIn ||
      !isSubscriber;


    const subRadio =
      document.getElementById('rc-radio1');

    const oneTimeRadio =
      document.getElementById('rc-radio2');


    const hiddenSubRadio =
      document.querySelector(
        '.rc-widget input.rc-radio__input.rc_widget__option__input--subsave'
      );

    const hiddenOneTimeRadio =
      document.querySelector(
        '.rc-widget input.rc-radio__input.rc_widget__option__input--onetime'
      );


    if (subRadio) {

      const label =
        subRadio.closest('label') ||
        document.querySelector(
          `label[for="${subRadio.id}"]`
        );


      const priceSpan =
        label
          ? label.querySelector('.rc-radio__price')
          : null;


      if (priceSpan) {

        const variantId =
          document
            .querySelector(
              '.custom-varinat-input-name:checked'
            )?.id;


        if (
          variantId &&
          !subRadio.dataset[`basePrice_${variantId}`]
        ) {

          const baseMatch =
            priceSpan.textContent.match(
              /\$?([0-9,.]+)/
            );

          if (baseMatch) {

            subRadio.dataset[
              `basePrice_${variantId}`
            ] =
              parseFloat(
                baseMatch[1]
              );
          }
        }


        let disPrice =
          $('.custom-varinat-input-name:checked')
            .attr(
              'variant_discount20_price'
            );


        $(".discount20_price")
          .text(disPrice);


        const selectedPricing = getSelectedVariantPricing();

        if (!selectedPricing) return;

        if (selectedPricing.oneTimeSavings > 0) {
          $(".onetimelimited")
            .text(formatBadgePercent(selectedPricing.oneTimePercent) + '% LIMITED TIME DEAL')
            .show();
        } else {
          $(".onetimelimited").hide();
        }

        $(".save-perct")
          .text(formatBadgePercent(selectedPricing.autoshipPercent) + '%');


        /*
         * ==========================================
         * GET ACTUAL SELECTED VARIANT
         * ==========================================
         */

        const variant =
          getSelectedVariant();


        if (!variant) return;


        /*
         * ==========================================
         * UPDATE "YOU SAVE" FROM CURRENT VARIANT
         * ==========================================
         */

        const variantPrice =
          Number(variant.price || 0);

        const compareAtPrice =
          Number(
            variant.compare_at_price || 0
          );


        /*
         * ONE-TIME SAVE
         *
         * Compare-at price - current variant price
         */

        let oneTimeSave = 0;


        if (
          compareAtPrice > variantPrice
        ) {

          oneTimeSave =
            (
              compareAtPrice -
              variantPrice
            ) / 100;
        }


        if (oneTimeSave > 0) {

          $(".custom-save-price-one")
            .text(
              "You Save $" +
              oneTimeSave.toFixed(2)
            )
            .removeClass(
              "hiddenactive"
            );

        } else {

          $(".custom-save-price-one")
            .text("")
            .addClass(
              "hiddenactive"
            );
        }


        /*
         * AUTOSHIP SAVE
         */

        const autoshipDiscount =
          isSubscriber
            ? 0.95
            : 0.80;


        const autoshipPriceForSave =
          variantPrice *
          autoshipDiscount;


        let autoshipSave = 0;


        if (compareAtPrice > 0) {

          autoshipSave =
            (
              compareAtPrice -
              autoshipPriceForSave
            ) / 100;

        } else {

          autoshipSave =
            (
              variantPrice -
              autoshipPriceForSave
            ) / 100;
        }


        if (autoshipSave > 0) {

          $(".custom-save-price-autoship")
            .text(
              "You Save $" +
              autoshipSave.toFixed(2)
            )
            .removeClass(
              "hiddenactive"
            );

        } else {

          $(".custom-save-price-autoship")
            .text("")
            .addClass(
              "hiddenactive"
            );
        }


        /*
         * ==========================================
         * EXISTING PRICE LOGIC
         * ==========================================
         */

        const oneTimePrice =
          variant.price / 100;


        const labelTextOoriginal =
          variant.price / 100;


        const priceToUse =
          variant.compare_at_price &&
          variant.compare_at_price > 0
            ? variant.compare_at_price
            : variant.price;


        const formattedPrice =
          '$' +
          (
            priceToUse / 100
          ).toFixed(2);


        $("#regularsa-cut-price")
          .text(formattedPrice);


        $(".orignal-price-data")
          .text(
            '$' +
            labelTextOoriginal
          );


        setTimeout(function () {

          const fivePercentDiscountPrice =
            (
              oneTimePrice *
              0.95
            ).toFixed(2);


          $("#discount-percentage-inner")
            .text(
              `$${fivePercentDiscountPrice} (-5%)`
            );

        }, 300);


        /*
         * AUTOSHIP BASE PRICE
         */

        let autoshipPrice =
          oneTimePrice;


        if (
          variant.selling_plan_allocations?.length
        ) {

          autoshipPrice =
            variant
              .selling_plan_allocations[0]
              .price / 100;
        }


        const finalPrice =
          shouldApplyDiscount
            ? (
                autoshipPrice *
                0.8421
              ).toFixed(2)
            : autoshipPrice.toFixed(2);


        /*
         * UPDATE UI
         */

        if (
          subRadio.checked &&
          priceSpan
        ) {

          priceSpan.textContent =
            `$${finalPrice}`;

          priceElement.textContent =
            `$${finalPrice}`;
        }


        const priceContainer =
          document.querySelector(
            '.rc-widget'
          );


        priceSpan.textContent =
          `$${finalPrice}`;


        if (subRadio.checked) {
          priceElement.textContent =
            `$${finalPrice}`;
        }


        if (shouldApplyDiscount) {

          if (
            priceContainer &&
            !priceContainer.querySelector(
              '.offer-sale-bfcm'
            )
          ) {

            const discountDiv =
              document.createElement(
                'div'
              );

            discountDiv.className =
              'offer-sale-bfcm';


            discountDiv.innerHTML =
              '<s>20%</s> <span><img src="https://cdn.shopify.com/s/files/1/0593/8521/7173/files/Vector_8.png"></span><p class="save-perct"></p> LIMITED TIME DEAL';


            priceContainer.prepend(
              discountDiv
            );
          }


          const subscriptionLabel =
            document.querySelector(
              '.rc-radio__subscription'
            );


          if (subscriptionLabel) {

            subscriptionLabel.textContent =
              'Autoship & Save 20%';
          }

        } else {

          if (
            priceContainer &&
            !priceContainer.querySelector(
              '.offer-sale-bfcm'
            )
          ) {

            const discountDiv =
              document.createElement(
                'div'
              );

            discountDiv.className =
              'offer-sale-bfcm';


            discountDiv.innerHTML =
              '<s>5%</s> <span><img src="https://cdn.shopify.com/s/files/1/0593/8521/7173/files/Vector_8.png"></span><p class="save-perct"></p> LIMITED TIME DEAL';


            priceContainer.prepend(
              discountDiv
            );
          }


          const subscriptionLabel =
            document.querySelector(
              '.rc-radio__subscription'
            );


          if (subscriptionLabel) {

            subscriptionLabel.textContent =
              'Autoship & Save 5%';
          }
        }


        if (
          subRadio.checked &&
          hiddenSubRadio
        ) {

          hiddenSubRadio.click();
        }
      }
    }


    /*
     * ==========================================
     * ONE-TIME RADIO
     * ==========================================
     */

    if (
      oneTimeRadio &&
      oneTimeRadio.checked
    ) {

      const label =
        oneTimeRadio.closest('label') ||
        document.querySelector(
          `label[for="${oneTimeRadio.id}"]`
        );


      const priceSpan =
        label
          ? label.querySelector(
              '.rc-radio__label'
            )
          : null;


      if (priceSpan) {

        const match =
          priceSpan.textContent.match(
            /\$?([0-9,.]+)/
          );


        const oneTimePrice =
          match
            ? parseFloat(match[1])
            : null;


        if (oneTimePrice) {

          priceElement.textContent =
            `$${oneTimePrice.toFixed(2)}`;

          window.baseVariantPrice =
            oneTimePrice;


          if (subRadio) {
            subRadio.removeAttribute(
              'data-base-price'
            );
          }
        }


        if (hiddenOneTimeRadio) {
          hiddenOneTimeRadio.click();
        }
      }
    }
  }


  /*
   * ==========================================
   * OBSERVER
   * ==========================================
   */

  const observer =
    new MutationObserver(
      (mutations, obs) => {

        const widget =
          document.querySelector(
            '.rc-widget'
          );


        if (widget) {

          const subRadio =
            document.getElementById(
              'rc-radio1'
            );

          const oneTimeRadio =
            document.getElementById(
              'rc-radio2'
            );


          if (subRadio) {

            subRadio.addEventListener(
              'change',
              updateRechargePrice
            );
          }


          if (oneTimeRadio) {

            oneTimeRadio.addEventListener(
              'change',
              updateRechargePrice
            );
          }


          updateRechargePrice();

          obs.disconnect();
        }
      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  window.updateRechargePrice =
    updateRechargePrice;

})();

/* Economy Pads count/size/scent availability rules */
(function () {
  const economyProductId = "7182694383765";

  function initEconomyVariantRules() {
    const productInput = document.querySelector(
      '.custom-varinat-input-name[data-product-id="' + economyProductId + '"]'
    );

    const wrapper = productInput && productInput.closest('variant-radios');
    if (!wrapper) return;

    const getInput = (name, value) =>
      Array.from(
        wrapper.querySelectorAll('.custom-varinat-input-name[name="' + name + '"]')
      ).find(input => input.value === value);

    const countInputs = Array.from(
      wrapper.querySelectorAll('.custom-varinat-input-name[name="Choose Count:"]')
    );

    const size23 = getInput('Pad Size', '23"x36"');
    const size28 = getInput('Pad Size', '28"x34"');
    const unscented = getInput('Scent', 'Unscented');
    const freshScent = getInput('Scent', 'Fresh Scent');

    if (!countInputs.length || !size23 || !size28 || !unscented || !freshScent) return;

    const checkedValue = name =>
      wrapper.querySelector('.custom-varinat-input-name[name="' + name + '"]:checked')?.value;

    const selectPair = (sizeInput, scentInput) => {
      sizeInput.checked = true;
      scentInput.checked = true;
    };

    const isValid300Pair = () => {
      const size = checkedValue('Pad Size');
      const scent = checkedValue('Scent');

      return (
        (size === '23"x36"' && scent === 'Unscented') ||
        (size === '28"x34"' && scent === 'Fresh Scent')
      );
    };

    const setOptionVisibility = (input, visible) => {
      const slide = input.closest('.slideitem');
      if (!slide) return;

      slide.hidden = !visible;
      slide.style.display = visible ? '' : 'none';
    };

    const applyVisibility = () => {
      const count = checkedValue('Choose Count:');
      const is300 = count === '300 Count';

      setOptionVisibility(size28, is300);
      setOptionVisibility(freshScent, is300);

      if (!is300) {
        selectPair(size23, unscented);
      } else if (!isValid300Pair()) {
        selectPair(size23, unscented);
      }
    };

    wrapper.addEventListener(
      'click',
      event => {
        const input = event.target.closest('.custom-varinat-input-name');
        if (!input || input.dataset.productId !== economyProductId) return;

        if (input.name === 'Choose Count:') {
          if (input.value !== '300 Count') {
            selectPair(size23, unscented);
          } else if (!isValid300Pair()) {
            selectPair(size23, unscented);
          }
        }

        if (checkedValue('Choose Count:') === '300 Count') {
          if (input.name === 'Pad Size') {
            selectPair(
              input.value === '28"x34"' ? size28 : size23,
              input.value === '28"x34"' ? freshScent : unscented
            );
          }

          if (input.name === 'Scent') {
            selectPair(
              input.value === 'Fresh Scent' ? size28 : size23,
              input.value === 'Fresh Scent' ? freshScent : unscented
            );
          }
        }

        setTimeout(applyVisibility, 0);
      },
      true
    );

    wrapper.addEventListener('change', () => setTimeout(applyVisibility, 0));
    applyVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEconomyVariantRules);
  } else {
    initEconomyVariantRules();
  }
})();

(function () {
  const priceValue = element => {
    const match = element?.textContent.match(/\$([0-9]+(?:\.[0-9]+)?)/);
    return match ? Number(match[1]) : null;
  };

  const productVariants = new WeakMap();

  const economyVariantFor = label => {
    if (label.dataset.prohandle !== 'economy-best-value-training-potty-pads-23x36-100-per-case') {
      return null;
    }

    const picker = label.closest('.custom-variant-picker');
    const targetInput = document.getElementById(label.htmlFor);
    const targetCount = Number.parseFloat(targetInput?.value);
    if (!picker || !targetInput || !targetCount) return null;

    let variants = productVariants.get(picker);
    if (!variants) {
      const variantData = picker.querySelector('script[type="application/json"]');
      try {
        variants = JSON.parse(variantData?.textContent || '[]');
      } catch {
        variants = [];
      }
      productVariants.set(picker, variants);
    }

    const selectedOptions = Array.from(
      picker.querySelectorAll('input.custom-varinat-input-name:checked')
    ).map(input => input.name === targetInput.name ? targetInput.value : input.value);

    const variant = variants.find(item =>
      item.options?.every((value, index) => value === selectedOptions[index])
    );

    return variant ? { variant, targetCount } : null;
  };

  const formatPerCount = value => Number(value.toFixed(2)).toString();

  const syncEconomyTargetPrice = label => {
    const match = economyVariantFor(label);
    if (!match) return;

    const slider = label.closest('.variantslider');
    const firstLabel = slider?.querySelector('.slideitem label.custom_input_change');
    const firstOnetime = priceValue(firstLabel?.querySelector('.count-result-onetime'));
    const firstAutoship = priceValue(firstLabel?.querySelector('.count-result-autoship'));
    const onetimePerCount = match.variant.price / 100 / match.targetCount;
    const autoshipFactor = firstOnetime && firstAutoship
      ? firstAutoship / firstOnetime
      : 0.8;
    const prices = {
      onetime: onetimePerCount,
      autoship: onetimePerCount * autoshipFactor
    };

    Object.entries(prices).forEach(([mode, value]) => {
      const price = label.querySelector('.count-result-' + mode);
      if (!price) return;
      const text = '$' + formatPerCount(value) + '/Count';
      if (price.textContent.trim() !== text) price.textContent = text;
    });
  };

  const updateSavings = label => {
    syncEconomyTargetPrice(label);
    const slider = label.closest('.variantslider');
    const firstLabel = slider?.querySelector('.slideitem label.custom_input_change');
    if (!firstLabel) return;

    ['onetime', 'autoship'].forEach(mode => {
      const firstPrice = priceValue(firstLabel.querySelector('.count-result-' + mode));
      const targetPrice = priceValue(label.querySelector('.count-result-' + mode));
      const savings = firstPrice !== null && targetPrice !== null
        ? Math.max(firstPrice - targetPrice, 0)
        : 0;
      const badge = label.querySelector('[data-most-loved-savings="' + mode + '"]');
      if (!badge) return;

      badge.hidden = savings < 0.005;
      badge.textContent = savings >= 0.005
        ? 'Save $' + savings.toFixed(2) + '/count'
        : '';
    });
  };

  const updateAllSavings = () => {
    document
      .querySelectorAll('[data-most-loved-target="true"]')
      .forEach(updateSavings);
  };

  document.addEventListener('change', () => {
    setTimeout(updateAllSavings, 50);
    setTimeout(updateAllSavings, 250);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllSavings);
  } else {
    updateAllSavings();
  }
})();

